import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { SiteProvider } from "./context/SiteContext";
import Layout from "./components/Layout";
import Cupones from "./pages/Cupones";
import Ofertas from "./pages/Ofertas";
import MiAhorro from "./pages/MiAhorro";
import ProximosCupones from "./pages/ProximosCupones";
import Login from "./pages/Login";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminCupones from "./pages/admin/Cupones";
import AdminConfiguracion from "./pages/admin/Configuracion";
import AdminEstadisticas from "./pages/admin/Estadisticas";

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="animate-spin w-8 h-8 border-4 border-canary border-t-transparent rounded-full"></div></div>;
  if (!user || !user.is_admin) return <Navigate to="/" />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <SiteProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            {/* Admin login - URL secreta que solo tú conoces */}
            <Route path="/acceso-admin" element={<Login />} />
            
            {/* Página pública */}
            <Route path="/" element={<Layout />}>
              <Route index element={<Cupones />} />
              <Route path="ofertas" element={<Ofertas />} />
              <Route path="mi-ahorro" element={<MiAhorro />} />
              <Route path="proximos-cupones" element={<ProximosCupones />} />
            </Route>
            
            {/* Panel de Admin */}
            <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
            <Route path="/admin/cupones" element={<AdminRoute><AdminCupones /></AdminRoute>} />
            <Route path="/admin/configuracion" element={<AdminRoute><AdminConfiguracion /></AdminRoute>} />
            <Route path="/admin/estadisticas" element={<AdminRoute><AdminEstadisticas /></AdminRoute>} />
            
            {/* Cualquier otra ruta va a cupones */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </BrowserRouter>
      </SiteProvider>
    </AuthProvider>
  );
}

export default App;
